/* import __COLOCATED_TEMPLATE__ from './column-control.hbs.js'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { selectColumn, removeSelectedColumns, setCellAttrs, getCellsInTable } from 'prosemirror-utils';
import { addColumnBefore, addColumnAfter } from 'prosemirror-tables';
import { tracked } from '@glimmer/tracking';
import { moveCursorToCell, getResponsiveClasses, getColumnCount } from '@intercom/composer-ember/lib/helpers/table';
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import { dispatchImageUpdate } from '@intercom/composer-ember/lib/helpers/image';
let ToolsTableEditorColumnControl = (_class = class ToolsTableEditorColumnControl extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "hoveredAction", _descriptor, this);
    _initializerDefineProperty(this, "insertionHoveredAction", _descriptor2, this);
  }
  get controlStyle() {
    let rect = this.args.controlPoint.clientRect;
    return sanitizeHtml(`
      left: ${rect.x}px;
      top: ${rect.y}px;
      width: ${rect.width}px;
      height: ${rect.height}px;
      `);
  }
  setHoveredAction(actionName) {
    this.hoveredAction = actionName;
    if (['insert-left', 'insert-right'].includes(actionName)) {
      this.insertionHoveredAction = actionName;
    } else {
      this.insertionHoveredAction = '';
    }
  }
  selectColumn() {
    let index = this.args.controlPoint.index;
    let tr = this.args.composer.state.prosemirrorState.tr;
    this.args.composer.commands.dispatch(selectColumn(index)(tr));
    this.args.composer.commands.focus();
  }
  insertColumnLeft() {
    this.selectColumn();
    addColumnBefore(this.args.composer.state.prosemirrorState, this.args.composer.commands.dispatch);
    this.addResponsiveClasses();
    dispatchImageUpdate(this.args.composer.config, this.transaction, this.dispatch);
    moveCursorToCell(this.args.composer, 0, this.columnIndex);
    this.addColumnAnalytics('added', 'left');
  }
  insertColumnRight() {
    this.selectColumn();
    addColumnAfter(this.args.composer.state.prosemirrorState, this.args.composer.commands.dispatch);
    this.addResponsiveClasses();
    dispatchImageUpdate(this.args.composer.config, this.transaction, this.dispatch);
    moveCursorToCell(this.args.composer, 0, this.columnIndex + 1);
    this.addColumnAnalytics('added', 'right');
  }
  deleteColumn() {
    this.selectColumn();
    let tr = this.args.composer.state.prosemirrorState.tr;
    this.args.composer.commands.dispatch(removeSelectedColumns(tr));
    this.addResponsiveClasses();
    moveCursorToCell(this.args.composer, 0, Math.max(0, this.args.controlPoint.index - 1));
    this.addColumnAnalytics('deleted', 'none');
  }
  addResponsiveClasses() {
    if (!this.table?.attrs.responsive) {
      return;
    }
    let responsiveClasses = getResponsiveClasses(getColumnCount(this.table));
    let cells = getCellsInTable(this.state.prosemirrorState.selection);
    cells?.forEach(cell => {
      let tr = this.transaction;
      this.args.composer.commands.dispatch(setCellAttrs(cell, {
        responsiveClasses
      })(tr));
    });
  }
  addColumnAnalytics(event, column_added) {
    this.args.composer.config.analytics?.trackAnalyticsEvent(event, {
      block_type: 'table',
      column_added
    });
  }
  get state() {
    return this.args.composer.state;
  }
  get columnIndex() {
    return this.args.controlPoint.index;
  }
  get transaction() {
    return this.args.composer.state.prosemirrorState.tr;
  }
  get dispatch() {
    return this.args.composer.commands.dispatch;
  }
  get table() {
    return this.state.currentlyActiveTable?.node;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "hoveredAction", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "insertionHoveredAction", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _applyDecoratedDescriptor(_class.prototype, "setHoveredAction", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setHoveredAction"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectColumn", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectColumn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertColumnLeft", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertColumnLeft"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertColumnRight", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertColumnRight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deleteColumn", [action], Object.getOwnPropertyDescriptor(_class.prototype, "deleteColumn"), _class.prototype), _class);
export { ToolsTableEditorColumnControl as default };